import { useProductsTFunction } from '@retail/products/i18n';
import { Stack, Tooltip, Typography } from '@mui/material';
import { Discontinuation } from '@retail/products/types';
import { AnnouncementOutlined } from '@mui/icons-material';
import { getDiscontinuationStatus } from '@retail/products/utils';

interface Props {
  liProps: React.HTMLAttributes<HTMLLIElement>;
  mgItemNumber: number;
  primaryText: string;
  secondaryText?: string;
  finfoNumber?: number;
  nobbNumber?: number;
  mgSupplierId: number;
  participantAccountName: string;
  externalItemSource: 'FINFO' | 'NOBB';
  includeSupplierInfo?: boolean;
  discontinuation: Discontinuation;
}

export function SearchResultItem({
  mgItemNumber,
  primaryText,
  secondaryText,
  finfoNumber,
  nobbNumber,
  mgSupplierId,
  participantAccountName,
  externalItemSource,
  includeSupplierInfo,
  discontinuation,
  liProps,
}: Props) {
  const t = useProductsTFunction();

  return (
    <Stack component={'li'} {...liProps} >
      <Stack flexDirection='row' alignItems='center' width='100%'>

        <Typography variant="subtitle2" noWrap flex={1} textAlign='center'>
          {primaryText}
        </Typography>
        {!!discontinuation && (discontinuation.discontinuationStatus === 'SOLD_OUT' || discontinuation.discontinuationStatus === 'REMOVED' || discontinuation.discontinuationStatus === 'EXPIRES_NO_REPLACEMENT')
          && (
            <Tooltip title={getDiscontinuationStatus(discontinuation.discontinuationStatus)} sx={{ flex: 1, flexDirection: 'row', justifyContent: "flex-end" }} >
              <div>
                <AnnouncementOutlined fontSize='small' color={discontinuation.discontinuationStatus === 'SOLD_OUT' ? 'secondary' : 'error'} />
              </div>
            </Tooltip>
          )}

      </Stack>
      <Typography variant="body2" noWrap>
        {secondaryText}
      </Typography>

      {includeSupplierInfo && (
        <Stack flexDirection="row" alignItems="center" gap={1}>
          <Typography variant="subtitle2">{t('products.supplier.name')}: </Typography>
          {`${participantAccountName}, ${mgSupplierId}`}
        </Stack>
      )}
      <Stack flexDirection="row" gap={2} >
        <Stack flexDirection="row" alignItems="center" gap={1}>
          <Typography variant="subtitle2">{t('products.mgItem.number.short')}: </Typography>
          {mgItemNumber}
        </Stack>
        <Stack flexDirection="row" alignItems="center" gap={1}>
          {externalItemSource === 'FINFO' ? (
            <>
              <Typography variant="subtitle2">
                {t('products.mgItem.supplierItem.finfoNumber.short')}:
              </Typography>
              {finfoNumber}
            </>
          ) : (
            <>
              <Typography variant="subtitle2">{t('products.nobb.number')}:</Typography>
              {nobbNumber}
            </>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
